// src/components/ProtectedRoute.tsx

import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { JWT_KEY } from "../utils/constants";
import { verifyToken } from "../utils/jwt";
import LoadingAnimation from "./LoadingAnimation";

const ProtectedRoute: React.FC = () => {
  const [isVerifyingToken, setIsVerifyingToken] = useState<boolean>(true);
  const [isTokenValid, setIsTokenValid] = useState<boolean>(false);
  const location = useLocation();
  const tokenString = Cookies.get(JWT_KEY);

  const isLoginPage = location.pathname === "/login";

  useEffect(() => {
    const verifyCurrentToken = async () => {
      if (tokenString) {
        try {
          await verifyToken(tokenString);
          setIsTokenValid(true);
        } catch (verifyError) {
          console.warn("Token verification failed:", verifyError);
          setIsTokenValid(false);
        }
      }
      setIsVerifyingToken(false);
    };

    verifyCurrentToken();
  }, [tokenString]);

  if (isLoginPage) {
    return <Outlet />;
  }

  if (isVerifyingToken) {
    return <LoadingAnimation text='Verifying authentication…' />;
  }

  if (!isTokenValid) {
    localStorage.setItem("redirectAfterLogin", location.pathname);
    return <Navigate to='/login' replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
